<template>
  <RygenMultiSelect
    :id="id"
    v-model="internalValue"
    :disabled="loading || disabled"
    :loading="loading"
    :options="options"
    :placeholder="t('glCodes.glCodes', 2)"
    class="gl-code-filter"
    display="chip"
    option-label="code"
    editable
    filter
  >
    <template #option="{ option }">
      <Chip class="gl-code-filter-option">
        {{ option.code }}
      </Chip>
    </template>
  </RygenMultiSelect>
</template>

<script lang="ts" setup>
import isEqual from 'lodash/isEqual';
import { PropType, ref, toRefs, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { GLCode } from '@rygen/rygen-ui/model';

import RygenMultiSelect from '@rygen/rygen-ui/components/form/RygenMultiSelect.vue';
import Chip from 'primevue/chip';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Array as PropType<GLCode[]>,
    default: () => [],
  },
  options: {
    type: Array as PropType<GLCode[]>,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const { id, modelValue, options, loading, disabled } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: GLCode[]): void;
}>();

const { t } = useI18n();

const internalValue = ref(modelValue.value);

watch(
  modelValue,
  (newVal: GLCode[]) => {
    internalValue.value = newVal;
  },
  { deep: true, immediate: true },
);

watch(
  internalValue,
  (newVal: GLCode[]) => {
    if (!isEqual(newVal, modelValue.value)) {
      emit('update:model-value', newVal);
    }
  },
  { deep: true },
);
</script>

<style>
.gl-code-filter {
  --p-chip-color: var(--info-color);
  --p-chip-background: var(--info-light-color);
  --p-chip-border-radius: var(--sp-1);
}
</style>
